module.exports = __webpack_public_path__ + "static/media/school.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/school.svg
// module id = 529
// module chunks = 0